import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";

import CustomerLivePcView from "./ViewMode/CustomerLivePcView";
import CustomerLiveMobileView from "./ViewMode/CustomerLiveMobileView";

import { GrTransaction } from "react-icons/gr";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import MenuUi from "../../../helpers/MenuUi/MenuUi";

import { transactionsCustomerContext } from "../../../context/CustomerContext/TransactionsCustomerContext/TransactionsCustomerContext";

const CustomerLiveTransactions = () => {
  const { setCounter, getLiveOrders, handleGetLiveOrders } = useContext(
    transactionsCustomerContext
  );

  //* Get Data Start
  const handleInitial = () => {
    setCounter((prevCounter) => prevCounter + 1);
    handleGetLiveOrders();
  };

  useEffect(() => {
    handleInitial();
    const interval = setInterval(handleInitial, 5000);
    return () => clearInterval(interval);
  }, []);
  //* Get Data End

  return (
    <>
      <SiteTitle title="معاملات فعال" />
      <div className="mr-auto w-full h-screen">
        <div
          className="flex w-full h-full justify-center overflow-y-scroll 
          items-start bg-mainBackground relative"
        >
          {/* Menu */}
          <MenuUi className={"top-2"} />
          {/* Items */}
          {isEmpty(getLiveOrders) ? (
            <>
              <span
                className="w-full h-full absolute space-y-5
                left-0 right-0 text-slate-200 text-xl
                flex flex-col justify-center items-center"
              >
                <span>
                  <GrTransaction size={60} />
                </span>
                <p>سفارشی وجود ندارد</p>
              </span>
            </>
          ) : (
            <>
              {/* PC View */}
              <span className="lg:flex hidden w-full">
                <CustomerLivePcView getLiveOrders={getLiveOrders} />
              </span>

              {/* Mobile View */}
              <span className="lg:hidden none w-11/12">
                <CustomerLiveMobileView getLiveOrders={getLiveOrders} />
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerLiveTransactions;
